import type { CommandBody } from '../CrossOriginMessage';

/**
 * Authenticates with token.
 */
export class AuthenticateCommandBody implements CommandBody {
  /**
   * Authentication token.
   */
  token: string;
}
